
const CJK_SYMBOLS_PUNCTUATION = [0x3000, 0x303F];
const KATAKANA_PUNCTUATION = [0x30FB, 0x30FC];
const HIRAGANA_CHARS = [0x3040, 0x309F];
const KATAKANA_CHARS = [0x30A0, 0x30FF];
const ZENKAKU_NUMBERS = [0xFF10, 0xFF19];
const ZENKAKU_PUNCTUATION_1 = [0xFF01, 0xFF0F];
const ZENKAKU_PUNCTUATION_2 = [0xFF1A, 0xFF1F];
const ZENKAKU_PUNCTUATION_3 = [0xFF3B, 0xFF3F];
const ZENKAKU_PUNCTUATION_4 = [0xFF5B, 0xFF60];
const ZENKAKU_SYMBOLS_CURRENCY = [0xFFE0, 0xFFEE];
const KANA_PUNCTUATION = [0xFF61, 0xFF65];
const HANKAKU_KATAKANA = [0xFF66, 0xFF9F];
const COMMON_CJK = [0x4E00, 0x9FFF];
const RARE_CJK = [0x3400, 0x4DBF];
const LATIN_NUMBERS = [0x0030, 0x0039];
const MODERN_ENGLISH = [0x0000, 0x007f];
const HEPBURN_MACRON_RANGES = [
        [0x0100, 0x0101], // Ā ā
        [0x0112, 0x0113], // Ē ē
        [0x012a, 0x012b], // Ī ī
        [0x014c, 0x014d], // Ō ō
        [0x016a, 0x016b] // Ū ū
    ];
const SMART_QUOTE_RANGES = [
        [0x2018, 0x2019], // ‘ ’
        [0x201C, 0x201D] // “ ”
    ];


const JA_PUNCTUATION_RANGES = [
        CJK_SYMBOLS_PUNCTUATION,
        KANA_PUNCTUATION,
        KATAKANA_PUNCTUATION,
        ZENKAKU_PUNCTUATION_1,
        ZENKAKU_PUNCTUATION_2,
        ZENKAKU_PUNCTUATION_3,
        ZENKAKU_PUNCTUATION_4,
        ZENKAKU_SYMBOLS_CURRENCY
    ];

const KANA_RANGES = [
    HIRAGANA_CHARS,
    KATAKANA_CHARS,
    KANA_PUNCTUATION,
    HANKAKU_KATAKANA
];



const LOWERCASE_START = 0x61;
const LOWERCASE_END = 0x7A;
const UPPERCASE_START = 0x41;
const UPPERCASE_END = 0x5A;
const LOWERCASE_FULLWIDTH_START = 0xFF41;
const LOWERCASE_FULLWIDTH_END = 0xFF5A;
const UPPERCASE_FULLWIDTH_START = 0xFF21;
const UPPERCASE_FULLWIDTH_END = 0xFF3A;

const HIRAGANA_START = 0x3041;
const HIRAGANA_END = 0x3096;
const KATAKANA_START = 0x30A1;
const KATAKANA_END = 0x30FC;
const KANJI_START = 0x4E00;
const KANJI_END = 0x9FAF;
const LATIN_CHAR_START = 0x0041;
const LATIN_CHAR_END = 0x007a;
const PROLONGED_SOUND_MARK = 0x30FC;
const HALFWIDTH_PROLONGED_SOUND_MARK = 0xFF70;

const WHITE_SPACE = 0x0020;
const HALFWIDTH_WHITE_SPACE = 0x3000;

const KANA_SLASH_DOT = 0x30FB;


export const getInvalidJapaneseCharacter = (theString) => {
    var result = false;
    for (var i=0; i < theString.length; i++) {
        var valid = isCharWhiteSpace(theString.charAt(i))|| isCharJapanese(theString.charAt(i));
        if(!valid)
        {
            if(!result)
                result = theString.charAt(i);
            else
                result =result+","+  theString.charAt(i);

        }
    }
    return result;
};
export const getInvalidFuriganaCharacter = (theString) => {
    var result = false;
    for (var i=0; i < theString.length; i++) {
        var valid = isCharWhiteSpace(theString.charAt(i))|| isCharKana(theString.charAt(i));
        if(!valid)
        {
            if(!result)
                result = theString.charAt(i);
            else
                result =result+","+  theString.charAt(i);

        }
    }
    return result;
};

const isEmpty = (input) => {
    if (typeof input !== 'string') {
        return true;
    }
    return !input.length;
};
const isCharWhiteSpace = (char) =>{
    if (isEmpty(char)) return true;
    var theUnicode = char.charCodeAt(0) ;
    var theUnicodeT = theUnicode.toString(16).toUpperCase();
    //return theUnicode==WHITE_SPACE || theUnicode==HALFWIDTH_WHITE_SPACE;
    return true
};
const isCharLongDash =  (char) => {
    if (isEmpty(char)) return false;
    return char.charCodeAt(0) ===  PROLONGED_SOUND_MARK || char.charCodeAt(0) ===HALFWIDTH_PROLONGED_SOUND_MARK;
};
const isCharInRange =  (char ,start, end ) => {
    if (isEmpty(char)) return false;
    var code = char.charCodeAt(0);
    return start <= code && code <= end;
};

const isCharKatakana = (char) => isCharInRange(char,  KATAKANA_START,  KATAKANA_END);

const isCharHiragana =  (char) => {
    if (isEmpty(char)) return false;
    if (isCharLongDash(char)) return true;
    return isCharInRange(char, HIRAGANA_START, HIRAGANA_END);
};

const isCharKanji = (char) => isCharInRange(char,  KANJI_START,  KANJI_END);

const isCharKana = (char) => isCharHiragana(char) || isCharKatakana(char);

const isCharJapanese = (char) => isCharKana(char) || isCharLatin(char)|| isCharKanji(char);

const isCharLatin = (char) => {
    if  (isCharInRange(char,  LATIN_CHAR_START,  LATIN_CHAR_END)) return true;
    if  (isCharInRange(char,  LOWERCASE_FULLWIDTH_START,  LOWERCASE_FULLWIDTH_END)) return true;
    if  (isCharInRange(char,  UPPERCASE_FULLWIDTH_START,  UPPERCASE_FULLWIDTH_END)) return true;

    return false;
};